export function getCurrentTime(user_id) {
  const rand = Math.ceil(Math.random() * 9)
  const keep = rand + '' + (Array(8).join('0') + 1234).slice(-8) + '' + Date.parse(new Date()) / 1000
  return keep // 100000000011518423839
}

export function getLocalData(type) {
  var keep = ''
  var date = new Date()
  var y = date.getFullYear()
  var m = date.getMonth() + 1
  m = m < 10 ? '0' + m : m
  var d = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
  var h = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
  var f = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
  var s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()

  switch (type) {
    case 'y':
      return y
    case 'm':
      return y + '-' + m
    case 'd':
      return y + '-' + m + '-' + d
    case 'h':
      return y + '-' + m + '-' + d + ' ' + d
    case 'f':
      return y + '-' + m + '-' + d + ' ' + d + ':' + d
    case 's':
      return y + '-' + m + '-' + d + ' ' + d + ':' + d + ':' + s
    default:
      return ''
  }
}

export function formatData(date, type) {
  var y = date.getFullYear()
  var m = date.getMonth() + 1
  m = m < 10 ? '0' + m : m
  var d = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
  var h = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
  var f = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
  var s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()

  switch (type) {
    case 'y':
      return y
    case 'm':
      return y + '-' + m
    case 'd':
      return y + '-' + m + '-' + d
    case 'h':
      return y + '-' + m + '-' + d + ' ' + d
    case 'f':
      return y + '-' + m + '-' + d + ' ' + d + ':' + d
    case 's':
      return y + '-' + m + '-' + d + ' ' + d + ':' + d + ':' + s
    default:
      return ''
  }
}

export function objLength(input) {
  var type = toString(input)
  var length = 0
  if (type != '[object Object]') {
    // throw "输入必须为对象{}！"
  } else {
    for (var key in input) {
      if (key != 'number') {
        length++
      }
    }
  }
  return length
}
// 验证是否是手机号码
export function vailPhone(number) {
  let flag = false
  const myreg = /^(((13[0-9]{1})|(14[0-9]{1})|(17[0]{1})|(15[0-3]{1})|(15[5-9]{1})|(18[0-9]{1}))+\d{8})$/
  if (number.length != 11) {
    flag = flag
  } else if (!myreg.test(number)) {
    flag = flag
  } else {
    flag = true
  }
  return flag
}
// 验证是否西班牙手机(6开头 9位数)
export function ifSpanish(number) {
  let flag = false
  const myreg = /^([6|7|9]{1}(\d+){8})$/
  if (number.length != 9) {
    flag = flag
  } else if (!myreg.test(number)) {
    flag = flag
  } else {
    flag = true
  }
  return flag
}
// 浮点型除法
export function div(a, b) {
  var c
  var d
  var e = 0
  var f = 0
  try {
    e = a.toString().split('.')[1].length
  } catch (g) {}
  try {
    f = b.toString().split('.')[1].length
  } catch (g) {}
  return (c = Number(a.toString().replace('.', ''))), (d = Number(b.toString().replace('.', ''))), mul(c / d, Math.pow(10, f - e))
}
// 浮点型加法函数
export function accAdd(arg1, arg2) {
  var r1, r2, m
  try {
    r1 = arg1.toString().split('.')[1].length
  } catch (e) {
    r1 = 0
  }
  try {
    r2 = arg2.toString().split('.')[1].length
  } catch (e) {
    r2 = 0
  }
  m = Math.pow(10, Math.max(r1, r2))
  return ((arg1 * m + arg2 * m) / m).toFixed(2)
}
// 浮点型乘法
export function mul(a, b) {
  var c = 0
  var d = a.toString()
  var e = b.toString()
  try {
    c += d.split('.')[1].length
  } catch (f) {}
  try {
    c += e.split('.')[1].length
  } catch (f) {}
  return (Number(d.replace('.', '')) * Number(e.replace('.', ''))) / Math.pow(10, c)
}

// 遍历对象属性和值
export function displayProp(obj) {
  var names = ''
  for (var name in obj) {
    names += name + obj[name]
  }
  return names
}
// 去除字符串所有空格
export function sTrim(text) {
  return text.replace(/\s/gi, '')
}
// 去除所有:
export function replaceMaohao(txt) {
  return txt.replace(/\:/gi, '')
}
// 转换星星分数
export function convertStarArray(score) {
  // 1 全星,0 空星,2半星
  var arr = []
  for (var i = 1; i <= 5; i++) {
    if (score >= i) {
      arr.push(1)
    } else if (score > i - 1 && score < i + 1) {
      arr.push(2)
    } else {
      arr.push(0)
    }
  }
  return arr
}

export function flattenRegion(params) {
  const values = []
  for (let index = 0; index < params.length; index++) {
    values[index] = params[index].text
  }
  return values
}

/**
 * 函数说明：获取字符串长度
 * 备注：字符串实际长度，中文2，英文1
 * @param:需要获得长度的字符串
 */
export function getStrLength(str) {
  if (str == undefined) {
    return 0
  }
  var realLength = 0
  var len = str.length
  var charCode = -1

  for (var i = 0; i < len; i++) {
    charCode = str.charCodeAt(i)
    if (charCode >= 0 && charCode <= 128) {
      realLength += 1
    } else {
      realLength += 2
    }
  }
  return realLength
}
/**
 * js截取字符串，中英文都能用
 * @param str：需要截取的字符串
 * @param len: 需要截取的长度
 */
export function cutstr(str, len, cat) {
  if (str == undefined) {
    return ''
  }
  var str_length = 0
  var str_len = 0
  let str_cut = new String()
  str_len = str.length
  for (var i = 0; i < str_len; i++) {
    const a = str.charAt(i)
    str_length++
    if (escape(a).length > 4) {
      // 中文字符的长度经编码之后大于4
      str_length++
    }
    str_cut = str_cut.concat(a)
    if (str_length > len) {
      str_cut = str_cut.concat(cat || '...')
      return str_cut
    }
  }
  // 如果给定字符串小于指定长度，则返回源字符串；
  if (str_length < len) {
    return str
  }
}
// type 0 毫秒 1 秒 2 分 3 时
export function diffTime(startDate, endDate, type) {
  var dateBegin = new Date(startDate.replace(/-/g, '/'))
  var dateEnd = new Date(endDate.replace(/-/g, '/'))

  switch (type) {
    case 0:
      return parseInt(dateEnd - dateBegin)
    case 2:
      return parseInt(dateEnd - dateBegin) / 1000 / 60
    case 3:
      return parseInt(dateEnd - dateBegin) / 1000 / 60 / 60
    default:
      return parseInt(dateEnd - dateBegin) / 1000
  }
}

/*
 *   功能:实现VBScript的DateAdd功能.
 *   参数:interval,字符串表达式，表示要添加的时间间隔.
 *   参数:number,数值表达式，表示要添加的时间间隔的个数.
 *   参数:date,时间对象.
 *   返回:新的时间对象.
 *   var now = new Date();
 *   var newDate = DateAdd( "d", 5, now);
 *---------------   DateAdd(interval,number,date)   -----------------
 */
export function DateAdd(interval, number, date) {
  switch (interval) {
    case 'y ': {
      date.setFullYear(date.getFullYear() + number)
      return date
    }
    case 'q ': {
      date.setMonth(date.getMonth() + number * 3)
      return date
    }
    case 'M ': {
      date.setMonth(date.getMonth() + number)
      return date
    }
    case 'w ': {
      date.setDate(date.getDate() + number * 7)
      return date
    }
    case 'd ': {
      date.setDate(date.getDate() + number)
      return date
    }
    case 'h ': {
      date.setHours(date.getHours() + number)
      return date
    }
    case 'm ': {
      date.setMinutes(date.getMinutes() + number)
      return date
    }
    case 's ': {
      date.setSeconds(date.getSeconds() + number)
      return date
    }
    default: {
      date.setDate(date.getDate() + number)
      return date
    }
  }
}
